import { render, staticRenderFns } from "./PropertyFormGeneral.vue?vue&type=template&id=715b59a0&scoped=true&"
import script from "./PropertyFormGeneral.vue?vue&type=script&lang=js&"
export * from "./PropertyFormGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PropertyFormGeneral.vue?vue&type=style&index=0&id=715b59a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715b59a0",
  null
  
)

export default component.exports